module.exports = __webpack_public_path__ + "img/drag_drop.676fc968.svg";